import {
  VIEW_TEMPLATE_MODE,
  EDIT_TEMPLATE_MODE,
  APPLY_TEMPLATE_MODE,
  CREATE_TEMPLATE_MODE,
} from 'components/modules/theme-templates/constants';

export const MODE_MODAL_TITLES = {
  [VIEW_TEMPLATE_MODE]: 'View Theme Template',
  [EDIT_TEMPLATE_MODE]: 'Edit Theme Template',
  [CREATE_TEMPLATE_MODE]: 'Create Theme Template',
  [APPLY_TEMPLATE_MODE]: 'Apply Theme Template',
};

export const MODE_CTA_TITLES = {
  [VIEW_TEMPLATE_MODE]: 'Close',
  [EDIT_TEMPLATE_MODE]: 'Save',
  [APPLY_TEMPLATE_MODE]: 'Apply',
  [CREATE_TEMPLATE_MODE]: 'Create',
};

export const NAME_REQUIRED_ERROR = 'Name is required.';
export const TYPE_REQUIRED_ERROR = 'Type is required';
export const STYLE_RULES_REQUIRED_ERROR = 'Style rules are required.';
export const STYLE_RULE_NAME_AND_VALUE_REQUIRED_ERROR = 'Style rule name and value are required.';
export const STYLE_RULE_NAMES_MUST_BE_UNIQUE_ERROR = 'Style rule names must be unique.';
